'use client'

import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { TextField, TextFieldProps } from '@mui/material'

interface TextAreaInputControllerProps<T extends FieldValues> extends Omit<TextFieldProps, 'name'> {
    control: Control<T>
    name: Path<T>
}

export default function TextAreaInputController<T extends FieldValues>({
    control,
    name,
    ...props
}: TextAreaInputControllerProps<T>) {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <TextField
                    error={!!error}
                    helperText={error?.message}
                    multiline
                    onChange={onChange}
                    value={value || ''}
                    {...props}
                />
            )}
        />
    )
} 